module.exports = ".full {\n  width: 100%;\n}\n\n.delete {\n  margin-top: 8px;\n}\n\n.form {\npadding: 10px;\n}\n\n.delete {\n  background-color: red;\n  opacity: .5;\n}\n\n.delete:hover {\n  background-color: red;\n  opacity: .8;\n}\n\n.table {\n  margin: auto;\n}\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/entries/entries.component.css
// module id = ./src/app/components/entries/entries.component.css
// module chunks = main